import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Button,
  ButtonBase,
  Grid,
  LinearProgress,
  Typography,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';

import { ReactComponent as LeftArrow } from '../../assets/img/icon/ArrowLeft.svg';
import { useNavigationContext } from '../../context/Navigation/navigation.provider';
import { useAuthDataContext } from '../../context/auth/auth.provider';
import { useSidebarContext } from '../../context/sidebar/sidebar.provider';
import SharedDialog from '../SharedDialog/SharedDialog.component';

interface StepperSubHeaderProps {
  totalSteps?: number;
  step?: number;
  goBack?: () => void;
  closeAction?: () => void;
}

const StepperSubHeader: React.FC<StepperSubHeaderProps> = ({
  goBack,
  step,
  totalSteps,
  closeAction,
}) => {
  const history = useHistory();
  const { setIsStepper } = useSidebarContext();
  const [dialog, setDialog] = React.useState(false);
  const { embed } = useAuthDataContext();
  const { isInModuleRoot } = useNavigationContext();

  // COMPONENTE CON FLECHA NAVEGACION GO BACK

  // UTILIZADO POR...........................
  // - ASISTENCIAS / PEDIR GRUA
  // - CANCELAR POLIZA (flecha superior)
  // - MODIFICAR POLIZA
  // - DENUNCIAR SINIESTRO

  useEffect(() => {
    setIsStepper(true);
    return () => {
      setIsStepper(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SharedDialog
        open={dialog}
        onClose={() => setDialog(false)}
        content={
          <Box>
            <Typography variant="h6">¡Atención!</Typography>
            <Box my={2}>
              <Typography>
                ¿Estas seguro que quieres ir al inicio?, perderás los cambios
                realizados.
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  onClick={() => setDialog(false)}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    if (closeAction) {
                      closeAction();
                    }
                    embed
                      ? window.parent.postMessage({ return: 'overview' }, '*')
                      : history.push('/dashboard');
                  }}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <Box>
        <LinearProgress
          variant="determinate"
          color="primary"
          // color="secondary"
          value={
            step !== undefined && totalSteps
              ? ((step + 1) / totalSteps) * 100
              : 100
          }
        />
        <Grid container>
          <Grid item xs={11}>
            <Grid
              container
              direction="row"
              // justify="flex-start"
              // alignItems="center"
              justify="space-between"
              alignItems="center"
            >
              <Grid item xs={5} sm={4}>
                <Box
                  position="absolute"
                  left={'0'}
                  style={{ marginLeft: '10px', marginTop: '10px' }}
                >
                  <ButtonBase>
                    <LeftArrow
                      onClick={() => {
                        const currentPath = history.location.pathname;
                        if (!step && !totalSteps && goBack) {
                          if (isInModuleRoot(currentPath))
                            embed
                              ? window.parent.postMessage(
                                  { return: 'overview' },
                                  '*'
                                )
                              : goBack();
                          else goBack();
                        } else if (step && goBack && step > 0) {
                          goBack();
                        } else {
                          if (isInModuleRoot(currentPath))
                            embed
                              ? window.parent.postMessage(
                                  { return: 'overview' },
                                  '*'
                                )
                              : history.push('/dashboard');
                          else history.goBack();
                        }
                      }}
                    />
                  </ButtonBase>
                </Box>
              </Grid>
              <Grid item xs={5} sm={4}>
                <Box
                  display="flex"
                  zIndex="modal"
                  justifyContent="flex-end"
                  position="absolute"
                  right={'0'}
                  style={{ marginRight: '10px', marginTop: '10px' }}
                >
                  <ButtonBase>
                    <ClearIcon
                      color="primary"
                      // color="secondary"
                      onClick={() => {
                        setDialog(true);
                      }}
                    />
                  </ButtonBase>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default StepperSubHeader;
